import { TOrgHeirachyModel } from './org-heirarchy.types';

export const UTIL_ORG_HEIRARCHY = {
  isNodeSelected(nodeList: TOrgHeirachyModel['values']): boolean {
    return nodeList.some((node) => {
      if (node.children) {
        return UTIL_ORG_HEIRARCHY.isNodeSelected(node.children.nodes);
      } else {
        return node.enhancedNodeInfo.isSelected;
      }
    });
  },

  findNodePath(
    nodeList: TOrgHeirachyModel['values'],
    targetNode: TOrgHeirachyModel['values'][number],
  ): TOrgHeirachyModel['values'][number][] | undefined {
    if (nodeList) {
      for (const node of nodeList) {
        if (node.enhancedNodeInfo.id === targetNode.enhancedNodeInfo.id) {
          return [node];
        } else {
          if (node.children) {
            const path: TOrgHeirachyModel['values'][number][] | undefined = this.findNodePath(
              node.children.nodes,
              targetNode,
            );
            if (path !== undefined) {
              return [node, ...path];
            }
          }
        }
      }
    }
    return undefined;
  },
};
